import axios from 'axios';
import api from '../api';

export const fetchDashboardData = async () => {
  const endpoints = [
    'vehiculos',
    'combustibles', 
    'viajes',
    'infracciones',
    'conductores',
    'mantenimiento'
  ];

  try {
    // Map endpoints to api.get calls (baseURL already in api)
    const requests = endpoints.map(endpoint => api.get(`/${endpoint}/`));

    const responses = await Promise.all(requests);

    return {
      vehiculos: responses[0].data,
      combustibles: responses[1].data,
      viajes: responses[2].data,
      infracciones: responses[3].data,
      conductores: responses[4].data,
      mantenimientoData: responses[5].data
    };
  } catch (error) {
    throw new Error(`Failed to fetch dashboard data: ${error.message}`);
  }
};